
export class RegularExpression {

	public pattern: string = "";

	constructor(regex?: RegExp) {

		if (regex !== undefined) {

			this.pattern = regex.source;
		}
	}
}
